import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import css from './block1LeftCarousel.module.scss'
import {makeAutoObservable} from "mobx";
import * as Api from "api/api";
import AdvImgType from "enum/AdvImgType";
import Swiper from "swiper";
import classNames from "classnames";

class CarouselStore {
    list = []

    curIndex = 0

    setList(value) {
        this.list = value
    }

    setCurIndex(value) {
        this.curIndex = value
    }

    get cur() {
        return this.list?.[this.curIndex]
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const carouselStore = new CarouselStore()

function useFetchCarouselStore({setCarouselList}) {
    useEffect(() => {
        Api.advImgList({
            type: AdvImgType.web_home_carousel,
        }).then(data => {
            setCarouselList(data)
        })
    }, [])
}

const Index = ({className}) => {
    useFetchCarouselStore({setCarouselList: v => carouselStore.setList(v)})

    const swiperRef = useRef()
    useEffect(() => {
        if (!(swiperRef.current && carouselStore.list.length)) {
            return;
        }

        const mySwiper = new Swiper(swiperRef.current, {
            slidesPerView: 3,
            spaceBetween: 15,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            on: {
                slideChange() {
                    carouselStore.setCurIndex(this.activeIndex % carouselStore.list.length);
                }
            }
        })


        //鼠标覆盖停止自动切换
        swiperRef.current.onmouseover = function () {
            mySwiper.autoplay.stop();
        }

        //鼠标离开开始自动切换
        swiperRef.current.onmouseout = function () {
            mySwiper.autoplay.start();
        }
    }, [swiperRef.current, carouselStore.list.length]);

    function slidePrev() {
        swiperRef.current.swiper.slidePrev();
    }

    function slideNext() {
        swiperRef.current.swiper.slideNext();
    }

    return (
        <div className={classNames(css.root, className)}>
            {
                carouselStore.cur &&
                <div className={css.curImgWrapper}>
                    <img className={css.img} src={carouselStore.cur.file} alt=''/>
                </div>
            }

            <div className={css.imgListContainer}>
                <div className={css.arrowContainer}>
                    <img
                        className={css.icon}
                        src={require('./img/block1轮播左-active.png')}
                        alt=''
                        onClick={() => {
                            slidePrev()
                        }}
                    />
                    <img
                        className={css.icon}
                        src={require('./img/block1轮播右-active.png')}
                        alt=''
                        onClick={() => {
                            slideNext()
                        }}
                    />
                </div>
                <div className={classNames('swiper', css.swiper)} ref={swiperRef}>
                    <div className={classNames('swiper-wrapper', css.swiperWrapper)}>
                        {
                            carouselStore.list.map(item => {
                                const {id, file} = item;
                                return (
                                    <div key={id} className={classNames('swiper-slide', css.item)}>
                                        <img className={css.img} src={file} alt=''/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)